import React, { useEffect, useRef } from "react";
import Style from "../styles/navbar.module.scss";
import { HiMenuAlt2 } from "react-icons/hi";
import { useSelector, useDispatch } from "react-redux";
import { toggle, dropdown, clientLogoutState } from "../redux/index";
import { useNavigate } from "react-router-dom";
import Dashboard_Icon from "../assets/dashboard/Menu/Dashboard.png";
import Profile_Icon from "../assets/dashboard/Menu/profile.png";
import Logo_Icon from "../assets/auth/logo.png";
import Logout_Icon from "../assets/dashboard/Menu/logout.png";
import clientlogoimg from "../assets/dashboard/Menu/mini-logo.png";
import { clientRoutes } from "../routers/ClientRouters";

const Navbar = () => {
  const isbutton = useSelector((state) => state.navbar.button);
  const issidebar = useSelector((state) => state.navbar.sidemenu);
  const clientdata = useSelector((state) => state.client.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const arrowRef = useRef(null);
  const containerRef = useRef(null);

  const handleLogout = async () => {
    dispatch(clientLogoutState());
    navigate(clientRoutes.login);
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (
        containerRef.current &&
        containerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        arrowRef.current &&
        !arrowRef.current.contains(event.target)
      ) {
        if (issidebar) {
          dispatch(dropdown());
        }
      }
    };

    containerRef.current?.addEventListener("click", handleClick);

    return () => {
      containerRef.current?.removeEventListener("click", handleClick);
    };
  }, [issidebar, dispatch]);

  const dashboard = () => {
    navigate(clientRoutes.dashboard);
    dispatch(toggle());
  };

  const profile = () => {
    navigate(clientRoutes.profile);
    dispatch(toggle());
  };

  return (
    <div className={Style.navbarmaincontainer} ref={containerRef}>
      <nav className={Style.navbar}>
        <div className={Style.navbar_left}>
          <button
            className={Style.hamburger_icon}
            onClick={() => dispatch(toggle())}
          >
            {isbutton ? <HiMenuAlt2 /> : <HiMenuAlt2 />}
          </button>

          <div className={Style.logo}>
            <img src={Logo_Icon} />
          </div>
        </div>
        <div className={Style.navbar_right}>
          <div className={Style.user_info}>
            <div className={Style.user_logo}>
              <img src={clientlogoimg} />
            </div>

            <div className={Style.user_data}>
              <div className={Style.user_name}>
                <h1>
                  {clientdata?.name
                    ? clientdata.name.length > 18
                      ? `${clientdata.name.slice(0, 12)} ...`
                      : clientdata.name
                    : ""}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`${Style.sidebar} ${isbutton ? Style.open : ""}`}>
        <ul className={Style.menu}>
          <li onClick={dashboard} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Dashboard_Icon} />
                <span>DASHBOARD</span>
              </a>
            </div>
          </li>

          <li onClick={profile} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Profile_Icon} />
                <span>PROFILE</span>
              </a>
            </div>{" "}
          </li>
        </ul>

        <div className={Style.logout}>
          <button className={Style.logout_button} onClick={handleLogout}>
            <span>
              <img src={Logout_Icon} /> Logout
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
